import { BreathworkConfigurationUi, breathworkConfigurationUiFromJson } from './BreathworkConfigurationUi';
import { BreathworkSupportingDocs, breathworkSupportingDocsFromJson } from './BreathworkSupportingDocs';
import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export type BreathworkDifficultyLevel = 'BEGINNER' | 'INTERMEDIATE' | 'ADVANCED';

export interface BreathworkInfoStep {
  step: LocalizedString;
  description: LocalizedString;
}

export interface Breathwork {
  id: string;
  position: number;
  isEnabled: boolean;
  name: LocalizedString;
  secondaryNames: LocalizedString[];
  description: LocalizedString;
  goal: LocalizedString;
  activitiesIds: string[];
  teachingSteps: BreathworkInfoStep[];
  whenToUse: LocalizedString[];
  benefitsIds: string[];
  chakrasIds: string[];
  cautions: LocalizedString[];
  counterActedFeelingsIds: string[];
  bestForIntentionsIds: string[];
  score: number;
  difficultyLevel?: BreathworkDifficultyLevel;
  backgroundColor?: string;
  configurationUi?: BreathworkConfigurationUi | null;
  supportingDocs?: BreathworkSupportingDocs;
}

function infoStepFromJson(json: Record<string, unknown>): BreathworkInfoStep {
  return {
    step: localizedStringFromMap(json['step'] as Record<string, unknown>),
    description: localizedStringFromMap(json['description'] as Record<string, unknown>),
  };
}

export function breathworkFromJson(json: Record<string, unknown>): Breathwork {
  const rawSteps = json['teachingSteps'] ?? json['steps'];
  return {
    id: json['id'] as string,
    position: json['position'] as number,
    isEnabled: (json['isEnabled'] as boolean | undefined) ?? true,
    name: localizedStringFromMap(json['name'] as Record<string, unknown>),
    secondaryNames: json['secondaryNames'] != null
      ? (json['secondaryNames'] as Record<string, unknown>[]).map(localizedStringFromMap)
      : [],
    description: localizedStringFromMap(json['description'] as Record<string, unknown>),
    goal: localizedStringFromMap(json['goal'] as Record<string, unknown>),
    activitiesIds: (json['activities'] as string[] | undefined) ?? [],
    teachingSteps: (rawSteps as Record<string, unknown>[]).map(infoStepFromJson),
    whenToUse: json['whenToUse'] != null
      ? (json['whenToUse'] as Record<string, unknown>[]).map(localizedStringFromMap)
      : [],
    benefitsIds: (json['benefits'] as string[] | undefined) ?? [],
    chakrasIds: (json['chakras'] as string[] | undefined) ?? [],
    cautions: json['cautions'] != null
      ? (json['cautions'] as Record<string, unknown>[]).map(localizedStringFromMap)
      : [],
    counterActedFeelingsIds: (json['counteractedFeelings'] as string[] | undefined) ?? [],
    bestForIntentionsIds: (json['bestForIntentions'] as string[] | undefined) ?? [],
    score: json['score'] != null ? (json['score'] as number) : 0,
    difficultyLevel: json['difficultyLevel'] as BreathworkDifficultyLevel | undefined,
    backgroundColor: json['backgroundColor'] as string | undefined,
    configurationUi: json['configUi'] != null
      ? breathworkConfigurationUiFromJson(json['configUi'] as Record<string, unknown>)
      : null,
    supportingDocs: json['supportingDocs'] != null
      ? breathworkSupportingDocsFromJson(json['supportingDocs'] as Record<string, unknown>)
      : undefined,
  };
}
